import * as buffer from 'buffer';
import process from 'process/browser';

if (typeof window !== 'undefined') {
  window.Buffer = buffer.Buffer;
  window.process = process;

  // React 18 需要的 polyfills
  if (!window.global) {
    window.global = window;
  }

  // Node 18 相容性
  if (!window.setImmediate) {
    window.setImmediate = (fn, ...args) => setTimeout(() => fn(...args), 0);
  }
}
